import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '../../reducers/store'
import {
  storeSetNodeId,
  storeSetTotalChunks,
  storeSetTotalItems,
} from '../../reducers/replay.reducer'
import { TimeLineItem } from '../../contexts/replay.context'
import { storeSetChunks } from '../../reducers/replay.reducer'

export const useReplayStore = () => {
  const dispatch = useAppDispatch()
  const replayStore = useAppSelector((state) => state.replay)

  /**
   * Alias functions for the reducer
   */
  const setChunks = useCallback(
    (chunks: TimeLineItem[][]) => {
      dispatch(storeSetChunks(chunks))
    },
    [dispatch]
  )
  const setTotalItems = useCallback(
    (totalItems: number) => {
      dispatch(storeSetTotalItems(totalItems))
    },
    [dispatch]
  )

  const setTotalChunks = useCallback(
    (totalChunks: number) => {
      dispatch(storeSetTotalChunks(totalChunks))
    },
    [dispatch]
  )

  const setNodeId = useCallback(
    (nodeId: string) => {
      dispatch(storeSetNodeId(nodeId))
    },
    [dispatch]
  )

  const initialize = useCallback(
    ({
      nodeId,
      chunks,
      totalItems,
    }: {
      nodeId: string
      chunks: TimeLineItem[][]
      totalItems: number
    }) => {
      setNodeId(nodeId)
      setChunks(chunks)
      setTotalItems(totalItems)
      setTotalChunks(chunks.length)
    },
    [setNodeId, setChunks, setTotalItems, setTotalChunks]
  )

  return {
    chunks: replayStore.chunks,
    totalItems: replayStore.totalItems,
    totalChunks: replayStore.totalChunks,
    nodeId: replayStore.nodeId,
    setChunks,
    setTotalItems,
    setTotalChunks,
    setNodeId,
    initialize,
  }
}
